import { create } from "zustand";

import {
  NirvanaCheckResult,
  PatientDemographics,
} from "~/services/nirvana/types";

/**
 * In-memory only store for the Nirvana eligibility flow.
 *
 * Intentionally NOT wrapped in `persist`: demographics are PHI and must never
 * be written to localStorage/sessionStorage (see D-011 in
 * specs/nirvana-integration/requirements.md). A hard refresh clears them.
 *
 * `result` (status / payerName) is non-PHI and is kept here so the
 * coverage banner on the slot selection page can read it later (out of scope
 * for this session, but the data is already wired).
 */
type NirvanaStore = {
  demographics: PatientDemographics | null;
  setDemographics: (demographics: PatientDemographics) => void;
  clearDemographics: () => void;

  result: NirvanaCheckResult | null;
  setResult: (result: NirvanaCheckResult | null) => void;

  clear: () => void;
};

export const useNirvanaStore = create<NirvanaStore>()((set) => ({
  demographics: null,
  setDemographics: (demographics) => set({ demographics }),
  clearDemographics: () => set({ demographics: null }),

  result: null,
  setResult: (result) => set({ result }),

  clear: () => set({ demographics: null, result: null }),
}));
